import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64a79212"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ResponsiveRow = _resolveComponent("ResponsiveRow")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_ImageViewer = _resolveComponent("ImageViewer")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_app_page = _resolveComponent("app-page")!
  const _component_created_app = _resolveComponent("created-app")!
  const _component_disabled_app = _resolveComponent("disabled-app")!
  const _component_app_log = _resolveComponent("app-log")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_app_page, null, {
      fheader: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_form, {
            size: "default",
            ref: "queryForm",
            "label-width": "120px",
            model: _ctx.params,
            onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.handleSearch()), ["enter"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ResponsiveRow, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "应用名称",
                    prop: "appName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        placeholder: "请输入应用名称",
                        modelValue: _ctx.params.appName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.appName) = $event)),
                        modelModifiers: { trim: true },
                        maxlength: "200",
                        clearable: "",
                        onkeypress: "if(event.keyCode==13 || event.which==13){return false;}"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    "label-width": "0",
                    class: "margin-left-20"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "default",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSearch())),
                        onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.handleSearch()), ["enter"]))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 查询 ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        size: "default",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleReset()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 重置 ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      header: _withCtx(() => [
        (_ctx.$has(_ctx.permissionConfig.CREATE))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "default",
              onClick: _ctx.handleCreated
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 创建应用 ")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      main: _withCtx(({
          height
        }) => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          height: height,
          key: height,
          data: _ctx.tableData,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "appName",
              label: "应用名称",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "appCode",
              label: "应用编码",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "appLogo",
              label: "应用logo",
              align: "center",
              width: "100"
            }, {
              default: _withCtx(({ row }) => [
                (row.appLogo)
                  ? (_openBlock(), _createBlock(_component_ImageViewer, {
                      key: 0,
                      list: [row.appLogo]
                    }, {
                      default: _withCtx(({ view }) => [
                        _createVNode(_component_el_image, {
                          style: {"width":"80px","height":"80px"},
                          src: _ctx.$filters.ossUrl(row.appLogo),
                          class: "img-thumbnail__table",
                          fit: "cover",
                          onClick: view
                        }, null, 8, ["src", "onClick"])
                      ]),
                      _: 2
                    }, 1032, ["list"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "updateDimension",
              label: "更新维度",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.getEnumLabel(_ctx.UPDATE_DIMENSION_LIST, row.updateDimension)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "dataChannel",
              label: "用户体系",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.getEnumLabel(_ctx.USER_SYSTEM_LIST, row.dataChannel)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "adaptiveSystem",
              label: "适配系统",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.adaptiveSystemList), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "下载地址",
              align: "center",
              width: "200"
            }, {
              default: _withCtx(({ row }) => [
                (row.androidAddress)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Android：" + _toDisplayString(row.androidAddress), 1))
                  : _createCommentVNode("", true),
                (row.iosAddress)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_2, "IOS：" + _toDisplayString(row.iosAddress), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "isEnabled",
              label: "状态",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.getEnumLabel(_ctx.ENABLED_STATUS_LIST, row.isEnabled)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              align: "center",
              width: "250px",
              fixed: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_3, [
                  (_ctx.$has(_ctx.permissionConfig.UPDATE))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "text",
                        class: "flex-1",
                        onClick: ($event: any) => (_ctx.handelAppEdit(row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("编辑")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (row.isEnabled === _ctx.ENABLED_STATUS_ENUM.ENABLED && _ctx.$has(_ctx.permissionConfig.ENABLE))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "text",
                        class: "flex-1 text-red",
                        onClick: ($event: any) => (_ctx.handleDisabled(row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("停用")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (row.isEnabled === _ctx.ENABLED_STATUS_ENUM.DISABLED && _ctx.$has(_ctx.permissionConfig.ENABLE))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        type: "text",
                        class: "flex-1",
                        onClick: ($event: any) => (_ctx.handleEnable(row, _ctx.handleSearch))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("启用")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.$has(_ctx.permissionConfig.LOG))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 3,
                        type: "text",
                        class: "flex-1",
                        onClick: ($event: any) => (_ctx.handleShowLogs(row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("操作记录")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (row.isEnabled === _ctx.ENABLED_STATUS_ENUM.DISABLED && _ctx.$has(_ctx.permissionConfig.DELETE))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 4,
                        type: "text",
                        class: "flex-1 text-red",
                        onClick: ($event: any) => (_ctx.handleDel(row, _ctx.handleSearch))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["height", "data"])), [
          [_directive_loading, _ctx.tableLoading]
        ])
      ]),
      ffooter: _withCtx(() => [
        _createVNode(_component_el_row, {
          style: {"width":"100%"},
          type: "flex",
          justify: "end"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_pagination, {
              total: _ctx.tableTotal,
              "current-page": _ctx.params.pageNum,
              size: _ctx.params.pageSize,
              onSizeChange: _ctx.handleSizeChange,
              onCurrentChange: _ctx.handleCurrentChange
            }, null, 8, ["total", "current-page", "size", "onSizeChange", "onCurrentChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_created_app, {
      visible: _ctx.createdAppVisible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.createdAppVisible) = $event)),
      accountAppItem: _ctx.accountAppItem,
      onHandleSearch: _ctx.handleSearch
    }, null, 8, ["visible", "accountAppItem", "onHandleSearch"]),
    _createVNode(_component_disabled_app, {
      visible: _ctx.disabledVisible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.disabledVisible) = $event)),
      accountAppItem: _ctx.accountAppItem,
      onHandleSearch: _ctx.handleSearch
    }, null, 8, ["visible", "accountAppItem", "onHandleSearch"]),
    _createVNode(_component_app_log, {
      visible: _ctx.logVisible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.logVisible) = $event)),
      logData: _ctx.gridData
    }, null, 8, ["visible", "logData"])
  ]))
}